<template>
  <div class="beneficios">
    <h1 class="section-title"> Conheça os benefícios de ter o Cartão de TODOS Coritiba!</h1>
    <div class="beneficios-container">
      <div>
        <div class="beneficios-card">
            <img class="beneficios-logo" src="./assets/logo-golstore.png" alt="Gol Store" />
            <h1 class="beneficios-title">10% de desconto </h1>
            <p class="beneficios-paragraph">Na loja online via cupom enviado para os filiados.</p>
        </div>
        <div class="beneficios-card">
            <img class="beneficios-logo" src="./assets/logo-decathlon.png" alt="Decathlon" />
            <h1 class="beneficios-title">5% de desconto</h1>
            <p class="beneficios-paragraph">Na loja online via cupom enviado para os filiados.</p>
        </div>
        <div class="beneficios-card">
            <img class="beneficios-logo" src="@/assets/icons/home-saude.svg" alt="Saúde" />
            <h1 class="beneficios-title">Saúde</h1>
            <p class="beneficios-paragraph">Descontos em consultas e exames. Consultas a partir de R$ {{ cdtPrices.clinico_geral }} em clínicas parceiras</p>
        </div>
        <div class="beneficios-card">
            <img class="beneficios-logo" src="@/assets/icons/home-educacao.svg" alt="Educação" />
            <h1 class="beneficios-title">Educação</h1>
            <p class="beneficios-paragraph">30 dias gratuitos na Refuturiza: educação + empregabilidade</p>
        </div>
        <div class="beneficios-card">
            <img class="beneficios-logo" src="@/assets/icons/home-lazer.svg" alt="Lazer" />
            <h1 class="beneficios-title">lazer</h1>
            <p class="beneficios-paragraph">Descontos em supermercados, restaurantes e mais</p>
        </div>
      </div>
    </div>
    <div class="home__discount__more">
        <a class="cta-link" href="https://torcedores.cartaodetodos.com.br/dados-pessoais/?idserv=44" @click="handleCTAClick">
            Peça já o seu
        </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { handleCTAClick } from "@/services/gtm";

export default {
  computed: {
    ...mapGetters(["cdtPrices"]),
  },
  methods: {
    handleCTAClick
  }
};
</script>

<style lang="scss">
.beneficios {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
    padding-bottom: 54px;
    padding-top: 54px;
}

.section-title {
    color: #F6D617;
    font-family: Arvo;
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px; /* 133.333% */
    text-align: center;
    margin-bottom: 32px;
    text-transform: uppercase;

    @media (max-width: 520px) {
        font-size: 24px;
        line-height: 36px; /* 150% */
    }
}

.beneficios-container {
    width: 100%;
    max-width: 892px;
    margin: 0 auto;

    @media (max-width: 900px) {
        padding-left: 42px;
        padding-right: 42px;
    }
    
    @media (max-width: 520px) {
        overflow-x: scroll;
        width: 100%;
    }

    & > div {
        display: grid;
        gap: 32px;
        grid-template-columns: repeat(3, 1fr);

        @media (max-width: 894px) {
            grid-template-columns: repeat(2, 1fr);
        }
    
        @media (max-width: 520px) {
            display: flex;
            width: min-content;
        }
    }
}

.beneficios-card {
    align-items: flex-start;
    aspect-ratio: 1;
    background: #FFFFFF;
    border: 1px solid #000;
    border-radius: 16px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.10);
    display: flex;
    flex-direction: column;
    gap: 15px;
    justify-content: flex-start;
    padding: 32px;

    @media (max-width: 520px) {
        aspect-ratio: 212 / 187;
        box-sizing: content-box;
        min-width: 212px;
    }
}

.beneficios-logo {
    display: block;
    height: auto;
    max-width: 100%;
}

.beneficios-title {
    color: #2F3635;
    font-family: Arvo;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
}

.beneficios-paragraph {
    color: #636365;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.cta-link {
    margin-top: 19px;

    @media (max-width: 520px) {
        font-size: 20px;
        width: 328px;
    }

    button {
        padding: 9px 27px;

        @media (max-width: 520px) {
            padding: 10px 27px;
            width: 100%;
        }
    }
}
</style>